import { RecentResultTypePercentage } from '../../../api/recentResultPercentage';
import { RecentResultsType } from '../../../api/recentResults';
import { useGameSelector } from '../../GameStore';

export const useMwGameStateSlice = {
  recentResultsCount: (): number => {
    return useGameSelector(({ mwGameState }) => mwGameState.recentResultsCount);
  },
  recentResults: (): RecentResultsType | null => {
    return useGameSelector(({ mwGameState }) => mwGameState.recentResults);
  },
  recentResultPercentage: (): RecentResultTypePercentage | null => {
    return useGameSelector(({ mwGameState }) => mwGameState.recentResultPercentage);
  },
};
